import { render, staticRenderFns } from "./IngresosEgresos.vue?vue&type=template&id=2a891510"
import script from "./IngresosEgresos.vue?vue&type=script&lang=js"
export * from "./IngresosEgresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports